var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('headroom',{attrs:{"zIndex":500,"offset":58,"id":"nav"}},[_c('img',{staticClass:"animated flip",attrs:{"id":"website-brand","src":"/images/bruceit.png","alt":"bruceit.com"}}),_vm._v(" "),_c('ul',[_c('li',[_c('a',{staticClass:"index",attrs:{"href":"/"}},[_vm._v("首页")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"category",attrs:{"href":_vm.url}},[_vm._v("专题")])])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c844b6c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/web/components/article/nav.vue
// module id = 157
// module chunks = 4